var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.viewShow),expression:"viewShow"}],staticClass:"totalBox"},[(_vm.isPc)?_c('pcView'):_c('h5View')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }